import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@mui/material';

function ReportDialog({ open, plateNumber, comments, onClose, onSubmit, setReportDialog, t }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('bookings.report_problem')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('bookings.report_problem_prompt')}</DialogContentText>
        <TextField
          fullWidth
          label={t('report.number_plate')}
          value={plateNumber}
          onChange={(e) =>
            setReportDialog((prev) => ({ ...prev, plateNumber: e.target.value }))
          }
          margin="normal"
        />
        <TextField
          fullWidth
          label={t('report.comments')}
          value={comments}
          onChange={(e) =>
            setReportDialog((prev) => ({ ...prev, comments: e.target.value }))
          }
          multiline
          rows={4}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t('actions.cancel')}
        </Button>
        <Button onClick={onSubmit} color="primary">
          {t('actions.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReportDialog;
